'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateUnseenThreadsCount = undefined;

var _reselect = require('reselect');

var _threadGetters = require('conversations-schema/thread/operators/threadGetters');

var _getSelectedThread = require('../../selected-thread/selectors/getSelectedThread');

var _calculateUnseenThreadsCountExcludeCurrent = require('./calculateUnseenThreadsCountExcludeCurrent');

var calculateUnseenThreadsCount = exports.calculateUnseenThreadsCount = (0, _reselect.createSelector)([_getSelectedThread.getSelectedThread, _calculateUnseenThreadsCountExcludeCurrent.calculateUnseenThreadsCountExcludeCurrent], function (selectedThread, unseenCount) {
  if (!selectedThread) {
    return unseenCount;
  }

  return unseenCount + ((0, _threadGetters.getUnseenCount)(selectedThread) ? 1 : 0);
});